export function SignOnIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4.14871 17.6155H10.2823C10.5792 17.6155 10.8198 17.3749 10.8198 17.078C10.8198 16.7811 10.5792 16.5405 10.2823 16.5405H4.14871C3.55578 16.5405 3.07366 16.0584 3.07366 15.4654L3.07366 4.1501C3.07366 3.55717 3.55578 3.07505 4.14871 3.07505L10.2823 3.07505C10.5792 3.07505 10.8198 2.83441 10.8198 2.53753C10.8198 2.24065 10.5792 2 10.2823 2L4.14871 2C2.96285 2 1.99861 2.96424 1.99861 4.1501L1.99861 15.4646C1.99861 16.6505 2.96285 17.6147 4.14871 17.6147V17.6155Z"
        fill="white"
      />
      <path
        d="M6.36491 10.3446L15.8394 10.3446C16.1363 10.3446 16.377 10.1039 16.377 9.80706C16.377 9.51018 16.1363 9.26953 15.8394 9.26953L6.36491 9.26953C6.06803 9.26953 5.82739 9.51018 5.82739 9.80706C5.82739 10.1039 6.06803 10.3446 6.36491 10.3446Z"
        fill="white"
      />
      <path
        d="M13.8434 12.5734C13.95 12.5734 14.0584 12.5411 14.1526 12.475L17.3116 10.2463C17.4547 10.1454 17.5391 9.9817 17.5391 9.80721C17.5391 9.63272 17.4539 9.46898 17.3116 9.36809L14.1526 7.13942C13.9103 6.96824 13.5746 7.02613 13.4034 7.26843C13.2322 7.51073 13.2901 7.84648 13.5324 8.01766L16.0687 9.80721L13.5324 11.5959C13.2901 11.7671 13.2322 12.102 13.4034 12.3452C13.5084 12.4932 13.6747 12.5726 13.8434 12.5726V12.5734Z"
        fill="white"
      />
    </svg>
  );
}
